const removeAuth = () => {
  localStorage.removeItem('memberData')
  localStorage.removeItem('memberAccessToken');
  localStorage.removeItem('isOnboarding');
  localStorage.removeItem('profileComplete');
  localStorage.removeItem('mustResetPassword');
}
const removeAdminAuth = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken');
  localStorage.removeItem('usertype');

}
const isCommitteeMember = () => {
  try {
    const status = JSON.parse(localStorage.getItem('memberData') || '{}')?.status;
    return status === 'Committee Member' || status === 'Office Bearer';
  } catch {
    return false;
  }
}
export { removeAuth, removeAdminAuth, isCommitteeMember }